import { UICONTROL_CX_CY_Multiple_CHOOSE_ARRAY, PROJECTTYPE_ENUM } from '@/utils/enums'
import { ActionVo, transLightValueToProp } from '@/utils/actionsHandler';
import { isMatched, getClassSkuAndVersion } from '@/utils/utils';
import { FindActionAbility, FindActionAbilityByClassSkuV2, FindActionAbilityByClassSkuUIConfig, isSupportToggerAbility, FindConfigAbility } from '@/axios/IDevice.js'
import { getSwitchKeyNameList, getSwitchKeyNameList2 } from '@/utils/getSwitchKeyNameList.js'
import { ProfessionalOnlyMsgType } from '@/configs/index';
import { warning } from '@/assets/js/common.js'
import { postWebIOSocket } from '@assets/socket';

const ifttt4Mixins = {
  data() {
    return {
      isTimeSequenceAutomation: false,
      isLoopAutomation: false,
      sequenceTaskList: [],
      timeModeOptions: [
        { value: 0, label: this.$t('iftttset.absoluteTime') },
        { value: 1, label: this.$t('iftttset.relativeDelay') }
      ],
      currentEditTask: null,
      currentEditIndex: -1,
      sequenceTaskTimeDialogVisible: false,
      currentSequenceTaskIndex: -1,
      currentSequenceActionIndex: -1,

      // 定时序列专用的添加逻辑数据
      sequenceActionlist: [],
      sequenceAddDevicesTemp: [],
      sequenceTemDevice: null,
      sequenceDeviceAction: [],
      sequenceAllUIConfig: {},
      sequenceOptionsAdd: [
        {
          value: 'b',
          label: this.$t('iftttset.doswitchifttt')
        },
        {
          value: 'c',
          label: this.$t('sync.scene')
        },
        {
          value: 'f',
          label: this.$t('ifttt.areacontrol')
        },
        {
          value: 'd',
          label: this.$t('scene.device')
        }
      ],

      buttonSetStyle: {
        position: 'sticky',
        bottom: 0,
        padding: '0 20px',
        'z-index': '1001',
        width: 'auto',
        background: 'white',
        bordertop: '1px solid rgb(255, 255, 255)',
        right: '41px',
        border: 'solid 1px #e1e5e7',
        borderRadius: '5px',
        bottom: '5px',
        margin: 0,
        position: 'fixed'
      },
    }
  },

  methods: {
    // 定时序列专用：选择动作
    checkSequenceRadioAction(item, index) {
      this.cur = index;
      this.temAction = item;
      item.ischeck = !item.ischeck;
    },

    initIfttt4Data(param) {
      this.sequenceTaskList = []
      this.isTimeSequenceAutomation = param.TriggerType === 11;
      if (this.isTimeSequenceAutomation && param.ExecuteTaskList) {
        const tempTaskList = param.ExecuteTaskList.filter(task => task.ActionType === 12);
        tempTaskList.forEach((task, index) => {
          task.locationindex = index;
          if (!task.ActionList) {
            task.ActionList = [];
          }
          if (task.ActionList) {
            task.ActionList.forEach(action => {
              if (action.ActionType === 0) {
                action.ischeck = true;
              }
              if (action.ActionType === 3) {
                action.IFT_ID = action.IFT_ID || action.IFtttNo;
                action.IFT_Name = action.IFT_Name || action.IFtttName;
                action.IsEnable = typeof action.IsEnable === 'boolean' ? action.IsEnable : true;
                this.reverseAutomationTime(action.IFT_ID, action.IftttToggleInterval || 0);
              }
              if (action.ActionType === 6 && action.Values) {
                this.sequenceAreaActionFormat(action);
              }
            });
          }
        });
        
        this.sequenceTaskList = JSON.parse(JSON.stringify(tempTaskList));
        this.getAllSequenceActionAbility();
      }
    },

    // 定时序列专用：区控动作格式化
    sequenceAreaActionFormat(action) {
      if (!action.Values || !action.Values.length) return;

      const { ProjectType } = this.$store.state.projectinfor;
      const isAgriculture = ProjectType === PROJECTTYPE_ENUM.Agriculture;

      action.showControlModeRadio = action.Values.every(v => v.ChannelId === 65535) ? '1' : '2';
      
      this.controlModeRadio = action.showControlModeRadio;

      action.ActionList = action.Values
        .map(value => {
          const controlItem = this.filteredAreaControlActionList.find(item => {
            if (isAgriculture && action.showControlModeRadio === '2') {
              return item.ControlType === value.ControlType && item.ChannelId === value.ChannelId;
            }
            return item.ControlType === value.ControlType;
          });

          if (!controlItem) return null;

          const valueTemplate = controlItem.Values?.[0] || {};

          let defaultValue;
          if (controlItem.ControlType === 2) {
            defaultValue = '#' + value.Value.toString(16);
          } else if (controlItem.ControlType === 10) {
            defaultValue = String(value.Value);
          } else if (controlItem.ControlType === 4 && ActionVo.isLight(valueTemplate)) {
            const max = valueTemplate.Max || 255;
            const lightProp = transLightValueToProp({
              DefaultValue: value.Value,
              Min: valueTemplate.Min || 0,
              Max: max
            });
            defaultValue = lightProp.DefaultValue;
          } else {
            defaultValue = value.Value;
          }

          return {
            MsgType: controlItem.MsgType,
            ShowMode: -1,
            Desc: controlItem.Desc,
            ischeck: true,
            Values: [{
              KeyId: valueTemplate.KeyId,
              ValueType: valueTemplate.ValueType,
              Name: valueTemplate.Name,
              Min: valueTemplate.Min,
              Max: valueTemplate.Max,
              EnumValue: valueTemplate.EnumValue,
              IsShow: valueTemplate.IsShow,
              Type: valueTemplate.Type,
              DefaultValue: defaultValue
            }],
            ControlType: controlItem.ControlType,
            ChannelId: controlItem.ChannelId,
            ControlName: controlItem.ControlName
          };
        })
        .filter(act => act !== null);
    },

    // 获取所有定时序列中设备的能力表
    async getAllSequenceActionAbility() {
      const allDevices = [];
      this.sequenceTaskList.forEach(task => {
        if (task.ActionList) {
          task.ActionList.forEach(action => {
            if (action.ActionType === 0) {
              allDevices.push(action);
            }
          });
        }
      });

      if (!allDevices.length) return;

      const list = getClassSkuAndVersion(allDevices);
      if (!list.length) return;

      await this.getSequenceClassSkuUIConfig(list);

      const res = await FindActionAbilityByClassSkuV2(list);
      if (res?.StatusCode === this.$store.state.rightStatusCode) {
        this.functionSequenceEditorDoFindActionAbility(res.Result, allDevices);
      }
    },

    // 获取UI配置
    async getSequenceClassSkuUIConfig(list) {
      const info = await FindActionAbilityByClassSkuUIConfig(list);
      if (info.StatusCode === this.$store.state.rightStatusCode) {
        info.Result.forEach(item => {
          if (item.UIContent && item.UIContent.WebUIConfigV2) {
            this.sequenceAllUIConfig[item.ClassSku] = item.UIContent.WebUIConfigV2;
          }
        });
      }
    },

    // 编辑状态下设备能力表处理
    async functionSequenceEditorDoFindActionAbility(info, allDevices) {
      try {
        allDevices.forEach((item) => {
          const findInfo = info.find(res => res.ClassSku === item.ClassSku && res.FirmVersions.includes(item.LocalVersion));
          if (!findInfo) return;

          const actionList = JSON.parse(JSON.stringify(findInfo.ActionList));
          const rsActionList = actionList.filter(action => this.getIftttShowMode(action));

          if (item.ActionList && item.ActionList.length > 0) {
            const newActionList = [];
            item.ActionList.forEach(savedAction => {
              const matchedAction = rsActionList.find(a => a.MsgType === savedAction.MsgType);
              if (matchedAction) {
                const actionCopy = JSON.parse(JSON.stringify(matchedAction));
                actionCopy.ischeck = true;
                if (savedAction.Values && savedAction.Values.length > 0) {
                  savedAction.Values.forEach(savedValue => {
                    actionCopy.Values.forEach((v, idx) => {
                      if (v.KeyId === savedValue.KeyId) {
                        if (v.ValueType === 'UIControl_RGB_Color_Multiple_Choose') {
                          v.DefaultValue = savedValue.Value;
                        } else if (v.ValueType === 'UIControl_MultipleDropdownList') {
                          v.DefaultValue = String(savedValue.Value).split(',');
                        } else if (v.ValueType === 'UIControl_ColorPanel' || UICONTROL_CX_CY_Multiple_CHOOSE_ARRAY.includes(v.ValueType)) {
                          v.DefaultValue = savedValue.Value;
                        } else if (v.ValueType === 'UIControl_TianMu_PlaybackSpeed_Group') {
                          v.DefaultValue = savedValue.Value / 10;
                        } else if (ActionVo.isLight(v)) {
                          // 亮度类型，需要将实际值转换为百分比
                          const max = v.Max || 255;
                          const lightProp = transLightValueToProp({
                            DefaultValue: savedValue.Value,
                            Min: v.Min || 0,
                            Max: max
                          });
                          v.DefaultValue = lightProp.DefaultValue;
                          v.Max = 100;
                          v.Min = lightProp.Min;
                        } else {
                          v.DefaultValue = Number(savedValue.Value);
                        }
                        this.handlerStepActionItem(v);
                      }
                    });
                  });
                }
                newActionList.push(actionCopy);
              }
            });
            item.ActionList = newActionList;
          }

          // 与自定义自动化 functionEditorDoFindActionAbility 一致：BackupActionList 只合并进能力全集，不追加到 ActionList
          if (item.BackupActionList && item.BackupActionList.length) {
            item.BackupActionList.forEach(n => {
              const sameTypeList = rsActionList.filter(action => action.MsgType === n.MsgType);
              if (!sameTypeList.length) return;
              n.Values.forEach(t => {
                sameTypeList.forEach(m => {
                  m.Values.forEach((p, idx) => {
                    if (t.KeyId !== p.KeyId) return;
                    const actionVo = new ActionVo({ ...p, DefaultValue: t.Value });
                    if (ActionVo.isLight(actionVo) || ActionVo.isColorPanel(actionVo)) m.Values[idx] = actionVo;
                    if (p.ValueType === 'UIControl_RGB_Color_Multiple_Choose') p.DefaultValue = t.Value;
                    else if (p.ValueType === 'UIControl_MultipleDropdownList') p.DefaultValue = t.Value.split(',');
                    else if (p.ValueType === 'UIControl_ColorPanel' || UICONTROL_CX_CY_Multiple_CHOOSE_ARRAY.includes(p.ValueType)) p.DefaultValue = t.Value;
                    else if (p.ValueType === 'UIControl_TianMu_PlaybackSpeed_Group') p.DefaultValue = t.Value / 10;
                    else p.DefaultValue = Number(t.Value);
                    this.handlerStepActionItem(m.Values[idx]);
                  });
                });
              });
            });
          }

          // 处理allActionlist中的亮度Max值
          rsActionList.forEach(action => {
            if (action.Values) {
              action.Values.forEach(v => {
                if (ActionVo.isLight(v)) {
                  const lightProp = transLightValueToProp({
                    DefaultValue: v.DefaultValue || 0,
                    Min: v.Min || 0,
                    Max: v.Max || 255
                  });
                  v.DefaultValue = lightProp.DefaultValue;
                  v.Max = 100;
                  v.Min = lightProp.Min;
                }
              });
            }
          });

          item.allActionlist = rsActionList;
        });

        this.sequenceTaskList.forEach(task => {
          if (task.ActionList) {
            task.ActionList.forEach(action => {
              if (action.ActionType === 0) {
                const device = allDevices.find(d => d.VDeviceId === action.VDeviceId);
                if (device) {
                  action.allActionlist = device.allActionlist;
                }
              }
            });
          }
        });

      } catch (error) {
        console.log('定时序列获取action能力表失败', error);
      }
    },

    formatSequenceTaskActions(task) {
      if (!task.ActionList) return [];

      return task.ActionList.map(action => {
        const formattedAction = { ...action };
        switch (action.ActionType) {
          case 0:
            break;
          case 4:
            formattedAction.SceneName = action.SceneName;
            formattedAction.SceneNo = action.SceneNo;
            break;
          case 6:
            formattedAction.AreaName = action.AreaName;
            formattedAction.Gpno = action.Gpno;
            break;
        }
        return formattedAction;
      });
    },

    openSequenceTaskDialog(task = null, index = -1) {
      this.currentEditIndex = index;
      this.currentEditTask = task;
      this.sequenceTaskTimeDialogVisible = true;
    },

    handleSequenceTaskTimeConfirm(result) {
      if (this.currentEditIndex >= 0 && this.sequenceTaskList[this.currentEditIndex]) {
        const task = this.sequenceTaskList[this.currentEditIndex];
        if (result.TimeMode === 0) {
          task.TimeMode = 0;
          task.StartHour = result.StartHour;
          task.StartMinute = result.StartMinute;
          delete task.Offset;
          delete task.Longitude;
          delete task.Latitude;
        } else {
          task.TimeMode = result.TimeMode;
          task.Offset = result.Offset;
          task.Longitude = result.Longitude;
          task.Latitude = result.Latitude;
          delete task.StartHour;
          delete task.StartMinute;
        }
      } else {
        const task = {
          ActionType: 12,
          ActionName: `${this.$t('iftttset.timingSequenceAction')} ${this.sequenceTaskList.length + 1}`,
          ActionList: []
        };

        if (result.TimeMode === 0) {
          task.TimeMode = 0;
          task.StartHour = result.StartHour;
          task.StartMinute = result.StartMinute;
        } else {
          task.TimeMode = result.TimeMode;
          task.Offset = result.Offset;
          task.Longitude = result.Longitude;
          task.Latitude = result.Latitude;
        }

        this.sequenceTaskList.push(task);
      }

      this.sequenceTaskTimeDialogVisible = false;
      this.currentEditTask = null;
      this.currentEditIndex = -1;
      this.modifyItemClear();
    },

    handleSequenceTaskTimeClose() {
      this.sequenceTaskTimeDialogVisible = false;
      this.currentEditTask = null;
      this.currentEditIndex = -1;
    },

    deleteSequenceTask(index) {
      this.sequenceTaskList.splice(index, 1);
    },

    upMoveSequenceTask(index) {
      if (index > 0) {
        const temp = this.sequenceTaskList[index];
        this.sequenceTaskList[index] = this.sequenceTaskList[index - 1];
        this.sequenceTaskList[index - 1] = temp;
      }
    },

    downMoveSequenceTask(index) {
      if (index < this.sequenceTaskList.length - 1) {
        const temp = this.sequenceTaskList[index];
        this.sequenceTaskList[index] = this.sequenceTaskList[index + 1];
        this.sequenceTaskList[index + 1] = temp;
      }
    },

    // 定时序列专用：处理添加动作
    handleAddActionToSequenceTask(command, taskIndex) {
      this.currentSequenceTaskIndex = taskIndex;

      const actions = {
        b: () => {
          // 开关自动化
          this.dialogIfttt2 = true;
          this.is_click = true;
          this.checkShow = false;
        },
        c: () => {
          // 场景
          this.dialogVisible = true;
        },
        d: () => {
          // 设备
          if (this.isVisual) {
            this.$emit('openDiveceList', 'action', this.sequenceTaskList[taskIndex].ActionList || []);
            return;
          }
          this.dialogAction = true;
        },
        f: () => {
          // 区控
          this.temparealist = [];
          this.tempareacheckedarea = [];
          this.dialogAreaSelect = true;
          this.areaActionTempListDefault();
        }
      };

      if (actions[command]) {
        actions[command]();
      }
    },

    // 定时序列专用：确认选择设备
    async confirmSequenceAction(devices) {
      this.sequenceAddDevicesTemp = devices;
      postWebIOSocket('sync_info_removeall_event');
      this.sequenceTemDevice = devices[0];
      this.iftttPlantId = await this.handleTianMuInIfttt({
        ActionList: devices[0]?.allActionlist || devices[0].ActionList,
        VDeviceId: devices[0].VDeviceId
      });
      this.doFindSequenceActionAbility();
    },

    // 设备弹窗change事件统一处理
    handleDeviceDialogChange(devices) {
      if (this.isTimeSequenceAutomation) {
        this.confirmSequenceAction(devices);
      } else {
        this.confirmaction(devices);
      }
    },

    // 场景确认统一处理
    handleSceneConfirm(scenes) {
      if (this.isTimeSequenceAutomation) {
        this.confirmSequenceScene(scenes);
      } else {
        this.confirmScene(scenes);
      }
    },

    // 开关自动化确认统一处理
    handleIftttConfirm(ifttts) {
      if (this.isTimeSequenceAutomation) {
        this.confirmSequenceIfttt(ifttts);
      } else {
        this.confirmIfttt(ifttts);
      }
    },

    // 区控确认统一处理
    handleAreaConfirm() {
      if (this.isTimeSequenceAutomation) {
        this.confirmSequenceArea();
      } else {
        this.areaselectfinsh();
      }
    },

    // 设备能力面板确认统一处理
    handleOkAction() {
      if (this.isTimeSequenceAutomation) {
        this.okSequenceAction();
      } else {
        this.okaction();
      }
    },

    // 区控能力面板确认统一处理
    handleAddAreaAction() {
      if (this.isTimeSequenceAutomation) {
        this.addSequenceAreaAction();
      } else {
        this.addAreaAction();
        this.modifyItemClear();
      }
    },

    // 设备能力选择统一处理
    handleCheckRadioAction(actionInfo) {
      if (this.isTimeSequenceAutomation) {
        this.checkSequenceRadioAction(actionInfo);
      } else {
        this.checkRadioAction(actionInfo);
      }
    },

    // 定时序列专用：获取设备能力
    doFindSequenceActionAbility() {
      const para = {
        vDeviceId: this.sequenceTemDevice.VDeviceId,
        ChildId: this.sequenceTemDevice.ChildId ?? this.sequenceTemDevice.ChannelId
      };

      FindActionAbility(para, this.functionDoFindSequenceActionAbility);
      this.dialogAction = false;
      this.$emit('doFindActionAbility');
    },

    // 定时序列专用：处理设备能力回调
    async functionDoFindSequenceActionAbility(rs, param) {
      if (!this.$store.state.isProfessional) {
        rs.Result.ActionList = rs.Result.ActionList.filter(item => !ProfessionalOnlyMsgType.includes(item.MsgType));
      }

      if (rs.Result.ActionList) {
        this.cur = -1;
        this.sequenceActionPannelMethods(rs.Result.ActionList, param);

        const { ClassSku, LocalVersion } = this.sequenceTemDevice;
        await this.getSequenceClassSkuUIConfig([{ ClassSku, FirmVersions: [LocalVersion] }]);

        this.actionPannel = true && !this.TianmuIsShow;
      }
    },

    // 定时序列专用：处理能力面板
    sequenceActionPannelMethods(list, param) {
      this.sequenceActionlist = [];

      if (list.some(item => item.UI?.ActionDisabledBySettings?.[0])) {
        FindConfigAbility({ vDeviceId: this.sequenceTemDevice.VDeviceId }).then(res => {
          this.gpDetails = res.Result?.GpList || [];
        });
      }

      if (!list.length) return;

      list.forEach(n => {
        if (!this.getIftttShowMode(n)) return;

        let num = 0;
        n.hasName = false;

        n.Values.forEach((v, i) => {
          if (v.IsShow) num++;
          this.handlerStepActionItem(v);

          n.Values[i] = new ActionVo(v);

          const val = n.Values[i];
          if (val.ValueType === 'UIControl_ChooseRange') val.DefaultValue = [val.Min, val.Max];
          else if (val.ValueType === 'UIControl_MultipleDropdownList') val.DefaultValue = val.DefaultValue.split(',');
          else if (['UIControl_RGB_Color_Multiple_Choose', ...UICONTROL_CX_CY_Multiple_CHOOSE_ARRAY].includes(val.ValueType)) val.DefaultValue = val.DefaultValue;
          else val.DefaultValue = Number(val.DefaultValue);
        });

        if (num > 1) n.hasName = true;
        n.ischeck = false;
        this.sequenceActionlist.push(n);
      });

      // 处理编辑回显
      if (param && this.modifyItem &&
        param.vDeviceId === this.modifyItem.VDeviceId &&
        (param.ChildId === this.modifyItem.ChildId || param.ChildId === this.modifyItem.ChannelId)) {
        if (list.length && this.modifyItem.ActionList?.length) {
          this.deviceActionFilter(this.sequenceActionlist, this.modifyItem.ActionList);
          if (this.modifyItem.allActionlist) {
            const otherList = this.modifyItem.allActionlist.filter(item =>
              !this.modifyItem.ActionList.some(_item => _item.MsgType === item.MsgType)
            );
            this.deviceActionFilter(this.sequenceActionlist, otherList, false);
          }
        }
      }

      // 农业项目特殊处理
      if (this.$store.state.projectinfor.ProjectType === PROJECTTYPE_ENUM.Agriculture) {
        const { ClassSku, VDeviceId } = this.sequenceTemDevice;
        const batchSetAgricultureChannelSkus = Object.keys(this.$store.state.staticConfig.ChannelNameConfig);
        if (batchSetAgricultureChannelSkus.includes(ClassSku)) {
          getSwitchKeyNameList2({ VDeviceId, actionlist: this.sequenceActionlist });
        }
      }
    },

    // 定时序列专用：确认选择动作
    async okSequenceAction() {
      let _tempaction = [];
      const _tempList = this.sequenceActionlist;

      this.sequenceActionlist.filter((item, index, array) => {
        return isMatched(item, array, 2);
      }).forEach(n => {
        if (n.ischeck) {
          _tempaction.push(n);
        }
      });

      if (_tempaction.length === 0) {
        warning(this, this.$t('iftttset.SelecAction'));
        return;
      }

      const isCheck = this.checkTianmuSceneNo(_tempaction);
      if (!isCheck) {
        warning(this, this.$t('tianmu.noVideo'));
        return;
      }

      const hasItem = _tempaction.some(item => item.MsgType === "0x130F0000");
      const ProtocolType = this.sequenceAddDevicesTemp.map(item => item.ProtocolType);

      if (hasItem && !ProtocolType.includes(1)) {
        const VDeviceIds = this.sequenceAddDevicesTemp.map(item => item.VDeviceId);
        const FunctionTypes = ["OnOffToggle"];
        const params = { VDeviceIds, FunctionTypes };
        const res = await isSupportToggerAbility(params);

        if (res.StatusCode === this.$store.state.rightStatusCode) {
          const { OnOffToggle } = res.Result || [];
          const filterRes = OnOffToggle.filter(item => !item.GatewaySupport && !item.OtaGatewaySupport);
          const filterRes2 = OnOffToggle.filter(item => !item.GatewaySupport && item.OtaGatewaySupport);
          if (filterRes.length > 0) {
            this.ifttt3ToggerOkText = this.$t('install.getInfo');
            this.isSupportToggerflag = true;
            this.SupportToggerVisible = true;
            return;
          }
          if (filterRes2.length > 0) {
            this.ifttt3ToggerOkText = this.$t('visual.toUpgrade');
            this.isSupportToggerflag2 = true;
            this.SupportToggerVisible = true;
            return;
          }
        }
      }

      if (this.modifyItem != null && this.currentSequenceActionIndex >= 0) {
        // 编辑模式
        const currentTask = this.sequenceTaskList[this.currentSequenceTaskIndex];
        if (currentTask && currentTask.ActionList) {
          currentTask.ActionList[this.currentSequenceActionIndex].ActionList = _tempaction;
          currentTask.ActionList[this.currentSequenceActionIndex].allActionlist = _tempList;
        }
        this.setActionDefaultValue();
      } else if (this.sequenceAddDevicesTemp.length > 0) {
        // 新增模式
        const pushDevices = this.sequenceAddDevicesTemp.map(device => {
          const deepList = JSON.parse(JSON.stringify(_tempList));
          let _tempactionFiltered = deepList.filter((item, index, array) => {
            return isMatched(item, array, 2);
          }).filter(n => n.ischeck);

          return {
            ActionType: 0,
            VDeviceId: device.VDeviceId,
            DeviceName: device.DeviceName,
            AreaName: device.AreaName,
            ChannelId: device.ChildId ?? device.ChannelId,
            ClassSku: device.ClassSku,
            ChannelName: device.ChildName || device.ChannelName,
            Gpno: device.Gpno,
            ActionList: _tempactionFiltered,
            allActionlist: deepList,
            backupActionList: []
          };
        });

        // 添加到当前定时序列任务
        if (this.currentSequenceTaskIndex >= 0 && this.sequenceTaskList[this.currentSequenceTaskIndex]) {
          if (!this.sequenceTaskList[this.currentSequenceTaskIndex].ActionList) {
            this.sequenceTaskList[this.currentSequenceTaskIndex].ActionList = [];
          }
          this.sequenceTaskList[this.currentSequenceTaskIndex].ActionList.push(...pushDevices);
        }

        this.sequenceDeviceAction = this.sequenceDeviceAction.concat(pushDevices);
      }

      // 清理临时数据
      this.sequenceAddDevicesTemp = [];
      this.sequenceTemDevice = null;
      this.actionPannel = false;
      this.sequenceActionlist = [];
      this.modifyItemClear();
      this.currentSequenceTaskIndex = -1;
      this.currentSequenceActionIndex = -1;
    },

    // 定时序列专用：确认选择场景
    confirmSequenceScene(val) {
      this.dialogVisible = false;

      if (this.currentSequenceTaskIndex >= 0 && this.sequenceTaskList[this.currentSequenceTaskIndex]) {
        if (!this.sequenceTaskList[this.currentSequenceTaskIndex].ActionList) {
          this.sequenceTaskList[this.currentSequenceTaskIndex].ActionList = [];
        }

        val.forEach(n => {
          this.sequenceTaskList[this.currentSequenceTaskIndex].ActionList.push({
            ...n,
            ActionType: 4
          });
        });
      }

      this.currentSequenceTaskIndex = -1;
    },

    // 定时序列专用：确认选择开关自动化
    confirmSequenceIfttt(val) {
      this.dialogIfttt2 = false;

      if (this.currentSequenceTaskIndex >= 0 && this.sequenceTaskList[this.currentSequenceTaskIndex]) {
        if (!this.sequenceTaskList[this.currentSequenceTaskIndex].ActionList) {
          this.sequenceTaskList[this.currentSequenceTaskIndex].ActionList = [];
        }

        val.forEach(n => {
          n.IFT_ID = n.IFT_ID || n.IFtttNo;
          n.IFT_Name = n.IFT_Name || n.IFtttName;
          if (typeof n.IsEnable !== 'boolean') {
            n.IsEnable = true;
          }
          this.sequenceTaskList[this.currentSequenceTaskIndex].ActionList.push({
            IFT_ID: n.IFT_ID,
            IFT_Name: n.IFT_Name,
            ActionType: 3,
            IsEnable: n.IsEnable
          });
        });
      }

      this.currentSequenceTaskIndex = -1;
    },

    // 定时序列专用：确认选择区控
    confirmSequenceArea() {
      if (this.temparealist.length > 0) {
        this.tempareaactionPannel = true;
        this.dialogAreaSelect = false;
      } else {
        warning(this, this.$t('iftttset.SelecArea'));
      }
    },

    // 定时序列专用：添加区控动作到定时序列
    addSequenceAreaAction() {
      const selectedActions = JSON.parse(JSON.stringify(this.filteredAreaControlActionList))
        .filter(p => p.ischeck)
        .map(p => {
          const v = p.Values?.[0] || {};
          return {
            MsgType: p.MsgType,
            ShowMode: -1,
            Desc: p.Desc,
            ischeck: true,
            Values: [{
              KeyId: v.KeyId,
              ValueType: v.ValueType,
              Name: v.Name,
              Min: v.Min,
              Max: p.ControlType === 4 ? 100 : v.Max,
              EnumValue: v.EnumValue ? [...v.EnumValue] : undefined,
              IsShow: v.IsShow,
              Type: v.Type,
              DefaultValue: v.DefaultValue
            }],
            ControlType: p.ControlType,
            ControlName: p.ControlName,
            ChannelId: p.ChannelId
          };
        });

      if (selectedActions.length === 0) {
        warning(this, this.$t('iftttset.SelecAction'));
        return;
      }

      if (this.currentSequenceTaskIndex >= 0 && this.sequenceTaskList[this.currentSequenceTaskIndex]) {
        if (!this.sequenceTaskList[this.currentSequenceTaskIndex].ActionList) {
          this.sequenceTaskList[this.currentSequenceTaskIndex].ActionList = [];
        }

        const newAction = {
          Gpno: this.temparealist[0].id,
          AreaName: this.temparealist[0].label,
          ActionType: 6,
          ActionList: [...selectedActions],
          showControlModeRadio: this.controlModeRadio
        };

        if (this.currentSequenceActionIndex >= 0) {
          this.sequenceTaskList[this.currentSequenceTaskIndex].ActionList.splice(this.currentSequenceActionIndex, 1, newAction);
        } else {
          this.sequenceTaskList[this.currentSequenceTaskIndex].ActionList.push(newAction);
        }
      }

      this.tempareaactionPannel = false;
      this.areaActionTempListDefault();
      this.currentSequenceTaskIndex = -1;
      this.currentSequenceActionIndex = -1;
    },

    // 定时序列专用：修改动作
    modifySequenceAction(taskIndex, actionIndex, action) {
      this.currentSequenceTaskIndex = taskIndex;
      this.currentSequenceActionIndex = actionIndex;
      this.modifyItem = action;

      switch (action.ActionType) {
        case 0:
          // 设备动作修改
          this.sequenceTemDevice = action;
          this.sequenceAddDevicesTemp = [action];
          this.doFindSequenceActionAbility();
          break;
        case 4:
          // 场景修改
          this.dialogVisible = true;
          break;
        case 6:
          // 区控修改
          this.modifyItem = action;
          this.temparealist = [{ id: action.Gpno, label: action.AreaName }];
          this.tempareacheckedarea = [];
          this.areaActionTempListDefault();
          
          if (action.ActionList) {
            const { ProjectType } = this.$store.state.projectinfor;
            const isAgriculture = ProjectType === PROJECTTYPE_ENUM.Agriculture;
            
            this.controlModeRadio = action.showControlModeRadio || '1';
            
            this.filteredAreaControlActionList.forEach(item => {
              const match = action.ActionList.find(act => {
                if (isAgriculture && this.controlModeRadio === '2') {
                  return act.ControlType === item.ControlType && act.ChannelId === item.ChannelId;
                }
                return act.ControlType === item.ControlType;
              });
              
              item.ischeck = !!match;
              if (match && item.Values?.[0] && match.Values?.[0]) {
                item.Values[0].DefaultValue = match.Values[0].DefaultValue;
              }
            });
          }
          
          this.tempareaactionPannel = true;
          break;
        case 3:
          // 开关自动化反转时间设置
          action.IFT_ID = action.IFT_ID || action.IFtttNo;
          if (!action.IFT_ID) {
            warning(this, this.$t('iftttset.nodoiftttwarning'));
            return;
          }
          if (this.iftttReverseDelayTime?.[action.IFT_ID]) {
            this.iftttReverseValue1 = this.iftttReverseDelayTime[action.IFT_ID].hour?.toString() || '0';
            this.iftttReverseValue2 = this.iftttReverseDelayTime[action.IFT_ID].minute?.toString() || '0';
            this.iftttReverseValue3 = this.iftttReverseDelayTime[action.IFT_ID].second?.toString() || '0';
          } else {
            this.iftttReverseValue1 = '0';
            this.iftttReverseValue2 = '0';
            this.iftttReverseValue3 = '0';
          }
          this.iftttReverseDelayChecked = !!(
            this.iftttReverseDelayTime?.[action.IFT_ID] &&
            Object.keys(this.iftttReverseDelayTime[action.IFT_ID]).length > 0
          );
          this.iftttReverseVisible = true;
          break;
      }
    },

    // 定时序列专用：删除动作
    deleteSequenceAction(taskIndex, actionIndex) {
      if (this.sequenceTaskList[taskIndex] && this.sequenceTaskList[taskIndex].ActionList) {
        const [deletedAction] = this.sequenceTaskList[taskIndex].ActionList.splice(actionIndex, 1);
        if (deletedAction && deletedAction.ActionType === 3) {
          const iftttNo = deletedAction.IFT_ID || deletedAction.IFtttNo;
          if (iftttNo) {
            this.iftttReverseDelayTime[iftttNo] = {};
          }
        }
      }
    },

    processIfttt4DataForSave(postdata) {
      if (this.isTimeSequenceAutomation) {
        const formattedSequenceTasks = this.sequenceTaskList.map(task => {
          const formattedTask = {
            ActionType: 12,
            ActionName: task.ActionName,
            TimeMode: task.TimeMode,
            ActionList: []
          };

          if (task.TimeMode === 0) {
            formattedTask.StartHour = task.StartHour;
            formattedTask.StartMinute = task.StartMinute;
          } else {
            formattedTask.Offset = task.Offset;
            formattedTask.Longitude = task.Longitude;
            formattedTask.Latitude = task.Latitude;
          } 

          if (task.ActionList && task.ActionList.length > 0) {
            formattedTask.ActionList = task.ActionList.map(action => {
              const formattedAction = {
                ActionType: action.ActionType
              };

              switch (action.ActionType) {
                case 0:
                  formattedAction.VDeviceId = action.VDeviceId;
                  formattedAction.DeviceName = action.DeviceName;
                  formattedAction.AreaName = action.AreaName;
                  formattedAction.ChannelId = action.ChannelId;

                  if (action.ActionList && action.ActionList.length > 0) {
                    formattedAction.ActionList = action.ActionList
                      .filter(act => act.ischeck)
                      .map(act => ({
                        MsgType: act.MsgType,
                        Values: act.Values.map(v => {
                          let value;
                          if (typeof v.DefaultValue === 'object') {
                            value = v.DefaultValue;
                          } else {
                            value = this.LightActionValueSubmit(v);
                          }
                          return {
                            KeyId: v.KeyId,
                            Value: value
                          };
                        })
                      }));
                  } else {
                    formattedAction.ActionList = [];
                  }
                  // 与 main.js 自定义自动化保存一致：allActionlist 中未出现在 ActionList 的 MsgType 写入 backupActionList
                  formattedAction.backupActionList = [];
                  if (action.allActionlist && action.allActionlist.length) {
                    const savedMsgTypes = new Set((formattedAction.ActionList || []).map(a => a.MsgType));
                    const filterList = action.allActionlist.filter(item => {
                      let matched = isMatched(item, action.allActionlist, 2);
                      if (matched) {
                        matched = !savedMsgTypes.has(item.MsgType);
                      }
                      return matched;
                    });
                    const msgTypeJson = {};
                    filterList.forEach(m => {
                      if (msgTypeJson[m.MsgType]) return;
                      const _actionmodel = {
                        MsgType: m.MsgType,
                        Values: []
                      };
                      (m.Values || []).forEach(t => {
                        let value = this.LightActionValueSubmit(t);
                        if (Number.isInteger(t.UI?.step)) {
                          value = Math.ceil(value * t.UI.step);
                        }
                        _actionmodel.Values.push({
                          KeyId: t.KeyId,
                          Value: value
                        });
                      });
                      formattedAction.backupActionList.push(_actionmodel);
                      msgTypeJson[m.MsgType] = true;
                    });
                  }
                  break;

                case 4:
                  formattedAction.SceneName = action.SceneName;
                  formattedAction.SceneNo = action.SceneNo;
                  break;

                case 6:
                  formattedAction.Gpno = action.Gpno;
                  formattedAction.AreaName = action.AreaName;
                  if (action.ActionList && action.ActionList.length > 0) {
                    formattedAction.Values = action.ActionList
                      .filter(act => act.ischeck)
                      .map(act => {
                        const valueItem = act.Values?.[0];
                        let value;
                        if (act.ControlType === 2) {
                          // 颜色值，如 #ff0000
                          const _int = '0x' + valueItem.DefaultValue.substr(1);
                          value = parseInt(_int);
                        } else {
                          // 使用LightActionValueSubmit处理亮度等值
                          value = this.LightActionValueSubmit(valueItem);
                        }
                        return {
                          ControlType: act.ControlType,
                          ChannelId: this.$store.state.projectinfor.ProjectType === PROJECTTYPE_ENUM.Agriculture ? act.ChannelId : undefined,
                          Value: value
                        };
                      });
                  } else {
                    formattedAction.Values = [];
                  }
                  break;

                case 3:
                  formattedAction.IFtttNo = action.IFT_ID || action.IFtttNo;
                  formattedAction.IFtttName = action.IFT_Name || action.IFtttName;
                  formattedAction.IsEnable = action.IsEnable;
                  {
                    const iftttNo = action.IFT_ID || action.IFtttNo;
                    const reverseDelayTime = iftttNo ? this.iftttReverseDelayTime?.[iftttNo] : null;
                    const IftttToggleInterval =
                      (reverseDelayTime?.hour * 3600 || 0) +
                      (reverseDelayTime?.minute * 60 || 0) +
                      (reverseDelayTime?.second || 0);
                    formattedAction.IftttToggleInterval = IftttToggleInterval >= 0 ? IftttToggleInterval : undefined;
                  }
                  break;
              }

              return formattedAction;
            });
          }

          return formattedTask;
        });

        const nonSequenceTasks = postdata.ExecuteTaskList.filter(task => task.ActionType !== 12);
        postdata.ExecuteTaskList = [...nonSequenceTasks, ...formattedSequenceTasks];
        postdata.IFtttVersion = 4;
      }
      return postdata;
    },

    checkIfIfttt4(rs) {
      if (this.pageType === 'edit') {
        //IFtttVersion 自动化没有涉及到网关或者WIFI设备，它的版本就是0，不用IFtttVersion === 4 来判断
        this.isTimeSequenceAutomation = rs?.TriggerType === 11;
        this.isLoopAutomation = rs?.TriggerType === 10;
        return this.isTimeSequenceAutomation || this.isLoopAutomation;
      }
      return false;
    },

    getSequenceTaskTimeText(task) {
      if (task.TimeMode === 0) {
        return `${task.StartHour.toString().padStart(2, '0')}:${task.StartMinute.toString().padStart(2, '0')}`;
      } else if (task.TimeMode !== 0) {
        const modeLabel = task.TimeMode === 1 ? this.$t('iftttset.sunrise') : this.$t('iftttset.sunset');
        if (task.Offset === 0) {
          return `${modeLabel} ${this.$t('iftttset.hour')}`;
        } else if (task.Offset > 0) {
          return `${modeLabel}${this.$t('base.after')}${task.Offset}${this.$t('tianmu.minutes')}`;
        } else {
          return `${modeLabel}${this.$t('base.before')}${Math.abs(task.Offset)}${this.$t('tianmu.minutes')}`;
        }
      } else {
        return `${this.$t('iftttset.delay')}${task.Offset}${this.$t('tianmu.minutes')}`;
      }
    },

    cloneSequenceTask(task) {
      return JSON.parse(JSON.stringify(task));
    },

    getSequenceIftttNo(action) {
      return action?.IFT_ID || action?.IFtttNo || null;
    }
  }
};

export default ifttt4Mixins;
